import { makeAutoObservable } from 'mobx'
import { uiStore } from 'shared/store/uiStore'
import { BillingPath } from 'entities/ExportRouters'
import type { EntitiesStore } from 'entities/EntitiesExport'
import { EnumSuspendedVariant } from 'pages/suspended/store/types'

export class SuspendedPageStore {
  constructor(private _entities: EntitiesStore) {
    makeAutoObservable(this)
  }

  get isOwner() {
    const { usersStore, organizationStore } = this._entities

    return usersStore.user?.id === organizationStore.owner?.id
  }

  get variant() {
    if (!this.isOwner) {
      return EnumSuspendedVariant.disabled
    }

    if (this._entities.subscriptionStore.isCanceled) {
      return EnumSuspendedVariant.canceled
    }

    if (this._entities.subscriptionStore.isSuspended || this._entities.subscriptionStore.isUnpaid) {
      return EnumSuspendedVariant.suspended
    }

    return EnumSuspendedVariant.disabled
  }

  get title() {
    if (this.variant === EnumSuspendedVariant.canceled) {
      return 'Subscription canceled'
    }

    if (this.variant === EnumSuspendedVariant.suspended) {
      return 'Account suspended'
    }

    return 'Account disabled'
  }

  get description() {
    if (this.variant === EnumSuspendedVariant.canceled) {
      return 'Your subscription has been canceled. To restart your subscription click below.'
    }

    if (this.variant === EnumSuspendedVariant.suspended) {
      return 'Your subscription has been suspended due to a billing issue with your primary payment method.'
    }

    return 'Your account has been disabled. Please notify your organization owner to resolve this issue.'
  }

  get isRestartVisible() {
    return this.variant !== EnumSuspendedVariant.disabled
  }

  restartSubscription = () => {
    uiStore.changeRouteViaVue({
      path: `/${BillingPath.upgrade}`,
    })
  }

  logout = () => {
    this._entities.authStore.logout()
  }
}
